<template>
  <wrap>
    <div
      v-stlog="{ goDetail: feed }"
      class="card-preview-image"
      @click="jumpToDetail"
      :style="{ height: height }"
    >
      <thumb-image :src="feed.previewUrl"
        :width="width"
        :height="height"
      />
    </div>
    <card-title v-stlog="{ goDetail: feed }" @click="jumpToDetail">
      {{ title }}
    </card-title>
    <author :author-info="authorInfo" />
  </wrap>
</template>

<script>
import Wrap from '@/components/Card/parts/Wrap';
import CardTitle from '@/components/Card/parts/CardTitle';
import Author from '@/components/Author/Author';
import CardFeed from '@/components/base/Card/CardFeed';
import ThumbImage from './parts/ThumbImage';

export default {
  name: 'CardFullImage',

  props: {
    width: Number
  },

  mixins: [CardFeed],

  components: {
    Author,
    CardTitle,
    ThumbImage,
    Wrap
  },

  computed: {
    height() {
      const { imageWidth, imageHeight } = this.feed;

      return `${(this.width * imageHeight) / imageWidth}px`;
    }
  }
};
</script>
